/**
 * 360 Internet Protection
 *
 * Declares its WAR entries as bare globs (`images/*`, `promo/*`). Globs aren't
 * fetchable, so the probes target concrete files resolved out of the packed CRX.
 * Product icons are a good choice — they change far less often than code.
 *
 * Manifest verified against version 2.1.60.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'glcimepnljoholdmjchkloafkggfoijh';

export const internetProtection360: ExtensionDefinition = {
  id: ID,
  name: '360 Internet Protection',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 17_000_000,
  notes: 'Exposes images/* and promo/* to every origin; probes target resolved filenames.',
  signals: [
    {
      id: 'war-360safe-icon',
      kind: 'web-accessible-resource',
      description: 'Load images/360safe.png via <img> — the product icon, matched by the images/* grant.',
      weight: 1,
      run: () => probeImage(ID, 'images/360safe.png'),
    },
    {
      id: 'war-antitrack-icon',
      kind: 'web-accessible-resource',
      description: 'Load images/antitrack_16.png via <img> to corroborate.',
      weight: 0.5,
      run: () => probeImage(ID, 'images/antitrack_16.png'),
    },
  ],
};
